import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarPessoa from '../../components/modal/ModalCadastrarPessoa';
import ModalEditarPessoa from '../../components/modal/ModalEditarPessoa';
import ModalExcluirPessoa from '../../components/modal/ModalExcluirPessoa';
import Tabela from '../../components/Tabela';

function Pessoa() {
    const { Success, Error, openModal, setOpenModal, PessoasConsulta, ListaPessoaConsulta, loading, modalEditarPessoa, setModalEditarPessoa, setEdicaoPessoa, setPessoaAtualKey, modalExcluirPessoa, setModalExcluirPessoa, Permissao, ListaFiltroPessoa, totalRegistrosPessoa, filtroPessoa, totalRegistrosFiltroPessoa } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditPessoa = (props) => {
        setModalEditarPessoa(true)
        setPessoaAtualKey(props.key)
        setEdicaoPessoa(props)
    }

    const DeletarPessoa = (props) => {
        setPessoaAtualKey(props.key)
        setModalExcluirPessoa(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroPessoa(searchTerm, currentPage, pageSize);
        } else {
            ListaPessoaConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroPessoa : totalRegistrosPessoa;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));


    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar pessoas'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarPessoa &&
                <ModalEditarPessoa currentPage={currentPage} />
            }
            {modalExcluirPessoa &&
                <ModalExcluirPessoa currentPage={currentPage} />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarPessoa closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar pessoa</button>
                    }
                </div>
                {loading ? (
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                ) : (
                    <div className='card card-table'>
                        <h3 className='h3-demanda' style={h3Demanda}>Pessoas cadastradas</h3>
                        <Tabela
                            data={searchTerm.trim() !== "" ? filtroPessoa : PessoasConsulta}
                            columns={[
                                { label: "Nome", field: "nome", width: "40%" },
                                { label: "Cargo", field: "cargo", width: "40%", render: (x) => x?.cargo?.descricao || "-" },
                                {
                                    label: "Opções",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <button onClick={() => EditPessoa(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbPencil />
                                            </button>
                                            {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                                <button onClick={() => DeletarPessoa(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                    <TbTrash />
                                                </button>
                                            }
                                        </div>
                                    ),
                                },
                            ]}
                            loading={loading}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            setCurrentPage={setCurrentPage}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            onSearch={(term) => {
                                setCurrentPage(1);
                                if (term.trim() !== "") {
                                    ListaFiltroPessoa(term, 1, 10);
                                } else {
                                    ListaPessoaConsulta(1, 10);
                                }
                            }}
                            corTerciaria={corTerciaria}
                        />
                    </div>
                )}
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Pessoa;